import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HideMenuIfUnauthorizedDirective } from './hide-menu-if-unauthorized.directive';

@NgModule({
  declarations: [HideMenuIfUnauthorizedDirective],
  imports: [
    CommonModule,
  ],
  providers: [],
  exports: [HideMenuIfUnauthorizedDirective],
})
export class SecurityModule { }
